import { useTranslation } from 'react-i18next';
import { useOrg } from '@/contexts/OrgContext';
import { useMemberAccess } from '@/hooks/useMemberAccess';
import { cn } from '@/lib/cn';
import type { SettingsSectionId } from '@finvox/shared/member-access';

const SECTIONS: { id: string; sectionId: SettingsSectionId; labelKey: string }[] = [
  { id: 'settings-organization', sectionId: 'organization', labelKey: 'settings.organization' },
  { id: 'settings-branding', sectionId: 'branding', labelKey: 'settings.branding' },
  { id: 'settings-language', sectionId: 'language', labelKey: 'settings.language' },
  { id: 'settings-regional', sectionId: 'regional', labelKey: 'settings.regional' },
  { id: 'settings-users', sectionId: 'users', labelKey: 'settings.users' },
  { id: 'settings-cost-centers', sectionId: 'costCenters', labelKey: 'settings.costCenters' },
  { id: 'settings-security', sectionId: 'security', labelKey: 'settings.security' },
  { id: 'settings-e-invoicing', sectionId: 'eInvoicing', labelKey: 'settings.eInvoicing' },
  { id: 'settings-report-schedule', sectionId: 'reportSchedule', labelKey: 'settings.reportSchedule' },
  { id: 'settings-budget', sectionId: 'budget', labelKey: 'settings.budget' },
  { id: 'settings-tax-gl', sectionId: 'taxGl', labelKey: 'settings.taxGl' },
  { id: 'settings-fiscal-period', sectionId: 'fiscalPeriod', labelKey: 'settings.fiscalPeriod' },
  { id: 'settings-audit-log', sectionId: 'auditLog', labelKey: 'settings.auditLog' }
];

export function SettingsNav() {
  const { t } = useTranslation();
  const { org } = useOrg();
  const memberAccess = useMemberAccess();
  const showEInvoicing = org?.countryTemplate === 'eg' || org?.countryTemplate === 'sa';

  const items = SECTIONS.filter((s) => {
    if (s.sectionId === 'eInvoicing' && !showEInvoicing) return false;
    return memberAccess?.settings[s.sectionId] ?? false;
  });

  return (
    <nav
      aria-label={t('settings.nav')}
      className="sticky top-0 z-10 -mx-1 mt-4 flex flex-wrap gap-2 border-b border-[var(--fv-border)] bg-[var(--fv-bg)]/95 py-3 backdrop-blur-sm"
    >
      {items.map((s) => (
        <a
          key={s.id}
          href={`#${s.id}`}
          className={cn(
            'rounded-full border border-[var(--fv-border)] bg-[var(--fv-surface)] px-3 py-1 text-xs font-medium',
            'text-[var(--fv-text-muted)] transition-colors hover:border-[var(--fv-primary)]/40 hover:text-[var(--fv-text)]'
          )}
        >
          {t(s.labelKey)}
        </a>
      ))}
    </nav>
  );
}
